import React, {useState, useContext} from 'react';
import {setOptions} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {CKEditor} from "@ckeditor/ckeditor5-react";
import BalloonBlock from "@ckeditor/ckeditor5-build-balloon-block";
import '../styles/patientMedicalHistory.css';
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function PatientMedicalHistory({width, setPatient, patient, setDraft, locale}) {
    const {wsCall} = useContext(NetworkContext);
    const [pmh, setPmh] = useState(patient.pmh);

    const EditorChange = data => {
        setPmh(data);

        if (data && data.length % 10 === 0) {
            const item = {...patient};
            item.pmh = data;
            setPatient(item);

            const message = {
                type: 'wss',
                path: 'patient',
                action: 'update',
                data: {
                    patient: patient.id,
                    pmh: data
                }
            };
            wsCall(message);
        }
    }

    const EditorBlur = () => {
        setDraft(false);

        const item = {...patient};
        item.pmh = pmh;
        setPatient(item);

        const message = {
            type: 'wss',
            path: 'patient',
            action: 'update',
            data: {
                patient: patient.id,
                pmh: pmh
            }
        };
        wsCall(message);
    }

    return (
        <div className="cs-patient-medical-history-page">
            {width > 768 &&
                <div className="mbsc-row cs-patient-medical-history-title" />
            }
            <CKEditor
                id="editor-focus"
                config={{
                    toolbar: ['bold', 'italic', 'link'],
                    blockToolbar: ['heading', '|', 'bold', 'italic', 'link', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
                    placeholder: locale.patientMedicalHistory.a
                }}
                editor={BalloonBlock}
                data={pmh}
                onChange={(event, editor) => EditorChange(editor.getData())}
                onBlur={() => pmh !== patient.pmh ? EditorBlur() : null}
            />
            <div className="mbsc-row cs-patient-medical-history-footer" />
        </div>
    );
}

export default PatientMedicalHistory;
